import { properties } from '@/utils/properties';
import { Util } from '@/utils/util';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { EquipoPatronService } from '@services/catalogo/equipoPatron.service';
import { FormularioEquipoPatronComponent } from './formulario-equipo-patron/formulario-equipo-patron.component';
import { EquipoModel } from '@/store/catalogos/equipo';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-equipo-patron',
  templateUrl: './equipo-patron.component.html',
  styleUrls: ['./equipo-patron.component.scss']
})
export class EquipoPatronComponent {
PROP = properties;
  displayedColumns: string[] = ['claveInterna', 'nombre', 'modelo', 'serie','options'];
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private paginator1: MatPaginatorIntl,
    private equipoService: EquipoPatronService,
     private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private util: Util) {
    this.paginator1.itemsPerPageLabel = "Registros por página";
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.loadEquipo();

  }

  filterTable(event: Event) {
    const filtro = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filtro.trim().toLowerCase();
  }

  loadEquipo() {
    this.equipoService.getAll().subscribe(data => {
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });

  }


  new() {
    const dialogRef = this.dialog.open(FormularioEquipoPatronComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:true,update:false,view:false,row:null}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadEquipo();
      }
    });
  }

  update(row: EquipoModel) {
    const dialogRef = this.dialog.open(FormularioEquipoPatronComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:false,update:true,view:false,row:row}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadEquipo();
      }
    });
  }

  view(row: EquipoModel) {
    const dialogRef = this.dialog.open(FormularioEquipoPatronComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:false,update:false,view:true,row:row}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadEquipo();
      }
    });
  }
}
